import React from 'react';
import classNames from 'classnames';

import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import WelcomeParagraphs from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/WelcomeParagraphs';
import WelcomeLayout from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/Welcome/Layout';
import { staticAppUrl } from 'Consts/sharedUris';
import PropTypes from 'prop-types';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import useDarkHeaderTheme from 'Views/Onboarding/Hooks/useDarkHeaderTheme';
import WelcomeLowerContentWrapper
  from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/WelcomeLowerContent/WelcomeLowerContentWrapper';


const useStyles = makeStyles(theme => ({
  root: {},
  image: {
    backgroundImage: `url(${staticAppUrl}/image/onboarding/risk-tolerance-welcome-updated.png)`,
  },
  text: {
    margin: theme.spacing(2),
  },
  footer: {},
  welcomeBlurb: {},
  welcomeParagraph: {},
}));

export default function RiskToleranceWelcomeLayout({
  className,
}) {
  const classes = useStyles();
  useScrollTopOnMount();
  useDarkHeaderTheme();

  return (
    <WelcomeLayout
      classes={{
        root: classNames(className, classes.root),
        imageCardContainer: classes.image,
      }}
    >
      <WelcomeLowerContentWrapper>
        <WelcomeParagraphs
          className={classes.welcomeParagraph}
          paragraphs={[
            { text: 'How much potential loss are you willing to experience when it comes to your money?' },
            { text: 'This is an important question to answer because it helps guide which strategies make sense for your situation.' },
            { text: 'The next few screens will help determine your general attitude and approach to investing based on the answers you provide.' },
          ]}
        />
      </WelcomeLowerContentWrapper>
    </WelcomeLayout>
  );
}

RiskToleranceWelcomeLayout.propTypes = {
  className: PropTypes.string,
};

RiskToleranceWelcomeLayout.defaultProps = {
  className: '',
};
